import { useEffect } from "react";
import { useSelector } from "react-redux";

// Interfaces
import { ILocation } from "@/Common/interfaces/location";
import { IPayPlansFacade } from "@/PayPlans/types/facade";

// Hooks
import useCacheCleaner from "@/Common/hooks/CacheCleaner";

// Contexts
import { PayPlanProvider } from "@/PayPlans/context/PayPlans/PayPlanProvider";

// Layouts
import EmptyBody from "@Layouts/components/Basics/EmptyBody";

// Components
import PayPlansContainer from "@PayPlans/Layouts/PayPlansFacade/PayPlansContainer";

// MUI
import { Box } from "@mui/material";

// Images
import empty from "@/assets/images/commons/empty.png";

// Constants
const QUERY_IDENTIFIERS = ["htmlPayPlanView", "payPlan", "payPlansSidebarTree"];

function PayPlansFacade(props: Readonly<IPayPlansFacade>) {
	const { position, cacheManagement, children } = props;
	const location = useSelector((state: { location: { location: ILocation } }) => state.location.location);
	const { clearCache } = useCacheCleaner();

	useEffect(() => {
		return () => {
			if (cacheManagement?.clearAbsoluteIndexes?.length) {
				clearCache([...QUERY_IDENTIFIERS, ...cacheManagement.clearAbsoluteIndexes]);
			}
		};
	}, [clearCache, cacheManagement, location]);

	if (!position) {
		return (
			<Box px={2} py={2} sx={{ width: 1 }}>
				<EmptyBody
					image={empty}
					title={"Bad Pay Plan definition."}
					sx={{
						boxShadow: "none !important",
					}}
				/>
			</Box>
		);
	}

	return (
		<PayPlanProvider {...props} locationId={location?.locationId}>
			<PayPlansContainer location={location}>{children}</PayPlansContainer>
		</PayPlanProvider>
	);
}

export default PayPlansFacade;
